import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import Table from 'react-bootstrap/Table';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import AdminUserModal from '../AdminUserModal';
import Link from '../../Link';
import CustomPagination from '../../CustomPagination/CustomPagination';
import messages from '../../../locale/messages';
import debounce from '../../../helpers/debounce';
import { openAdminUserModal } from '../../../actions/siteadmin/modalActions';
import { deleteAdminUser } from '../../../actions/siteadmin/AdminUser/manageAdminUser';
import EditIcon from '../../../../public/Icons/edit.png';
import TrashIcon from '../../../../public/Icons/bin.svg';
import s from './AdminUserManagement.css';
import bt from '../../../components/commonStyle.css';

class AdminUserManagement extends Component {

  static defaultProps = {
    data: [],
    roles: []
  };

  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
      searchList: ''
    };
  }

  handleKeywordSearch = debounce((searchList) => {
    const { adminUsers: { refetch } } = this.props;
    let variables = {
      currentPage: 1,
      searchList,
    };
    this.setState({ searchList, currentPage: 1 });
    refetch(variables);
  });

  paginationData = (currentPage) => {
    const { adminUsers: { refetch } } = this.props;
    const { searchList } = this.state;
    let variables = { currentPage, searchList };
    this.setState({ currentPage });
    refetch(variables);
  };

  handleDelete = async (id) => {
    const { adminUsers: { refetch, getAllAdminUsers }, deleteAdminUser } = this.props;
    const { searchList, currentPage } = this.state;
    let variables = { currentPage: currentPage > 1 && getAllAdminUsers?.results?.length == 1 ? currentPage - 1 : currentPage, searchList };
    await deleteAdminUser(id);
    this.setState({ currentPage: variables.currentPage });
    refetch(variables);
  }

  render() {
    const { openAdminUserModal, roles } = this.props;
    const { adminUsers, adminUsers: { getAllAdminUsers } } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage } = this.state;
    let paginationLabel = formatMessage(messages.users);

    return (
      <div className={cx(s.widthInner, s.tableSection, 'whiteDropdown', 'widthInnerNoBorder')}>
        <AdminUserModal roles={roles} paginationData={this.paginationData} />
        <div className={s.container}>
          <div className={cx(s.padding2, s.paddingTop2, s.tabelExport)}>
            <div className={s.searchInput}>
              <FormControl type='text' placeholder={formatMessage(messages.search)}
                onChange={(event) => this.handleKeywordSearch(event.target && event.target.value)}
                className={s.formControlInput} />
            </div>
            <Button
              className={cx(s.addlinkBtn, 'textAlignLeftRTL')}
              onClick={() => openAdminUserModal('add')}>
              <FormattedMessage {...messages.addNewLabel} />
            </Button>
          </div>
          <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'NewAdminResponsiveTable')}>
            <Table className="table">
              <thead>
                <tr>
                  <th scope="col"><FormattedMessage {...messages.sNoLabel} /></th>
                  <th scope="col"><FormattedMessage {...messages.emailLabel} /></th>
                  <th scope="col"><FormattedMessage {...messages.adminRoleLabel} /></th>
                  <th scope="col"><FormattedMessage {...messages.edit} /></th>
                  <th scope="col"><FormattedMessage {...messages.delete} /></th>
                </tr>
              </thead>
              <tbody>
                {
                  adminUsers && getAllAdminUsers && getAllAdminUsers?.count > 0 && getAllAdminUsers?.results && getAllAdminUsers?.results?.map((value, key) => {
                    return (
                      <tr key={key}>
                        <td data-label={formatMessage(messages.sNoLabel)}>{key + 1}</td>
                        <td data-label={formatMessage(messages.emailLabel)}>{value.email}</td>
                        <td data-label={formatMessage(messages.adminRoleLabel)}>{value.adminRole && value.adminRole.name} </td>
                        <td data-label={formatMessage(messages.edit)}>
                          <Link noLink onClick={() => openAdminUserModal('edit', value)} className={s.cursorPointer}>
                            <span><img src={EditIcon} className={cx(s.editIcon, 'editIconRTL')} /></span>
                            <span className={s.vtrMiddle}>
                              <FormattedMessage {...messages.editAction} />
                            </span>
                          </Link>
                        </td>
                        <td data-label={formatMessage(messages.delete)}>
                          <Link noLink onClick={() => this.handleDelete(value.id)} className={s.cursorPointer}>
                            <img src={TrashIcon} className={cx(s.editIcon, 'editIconRTL')} />
                            <span className={s.vtrMiddle}>
                              <FormattedMessage {...messages.deleteAction} />
                            </span>
                          </Link>
                        </td>
                      </tr>
                    )
                  })
                }
                {
                  adminUsers && getAllAdminUsers && getAllAdminUsers?.count === 0 && <tr>
                    <td colSpan={50}><FormattedMessage {...messages.noResult} /></td>
                  </tr>
                }
              </tbody>
            </Table>
          </div>
          {
            adminUsers && getAllAdminUsers && getAllAdminUsers?.count > 0 && <div className={cx(s.space5, s.spaceTop5)}>
              <CustomPagination
                total={getAllAdminUsers.count}
                currentPage={currentPage}
                defaultCurrent={1}
                defaultPageSize={10}
                change={this.paginationData}
                paginationLabel={paginationLabel}
              />
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  openAdminUserModal,
  deleteAdminUser
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(AdminUserManagement)));